import { defineBoot } from '#q-app/wrappers'
import axios from 'axios'
import { useAuth } from 'stores/auth-store'

// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)
const api = axios.create({
  baseURL: process.env.AUTH_API_BASE || 'https://fire.rftuning.id',
})

// inject token
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('token')
  if (token) cfg.headers.Authorization = `Bearer ${token}`
  return cfg
})

// Interceptor response untuk logout otomatis jika session invalid
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status
    if (status === 401 || status === 403) {
      // Pastikan state Pinia juga dibersihkan (bukan hanya localStorage)
      try {
        const auth = useAuth()
        // Clear auth state tanpa memanggil API logout (karena session sudah invalid)
        auth.token = null
        auth.me = null
        localStorage.removeItem('token')
        localStorage.removeItem('me')
      } catch (e) {
        // Fallback jika store belum terinisialisasi
        console.log(e.message)
        localStorage.removeItem('token')
        localStorage.removeItem('me')
      }

      // Redirect ke login dengan membawa path saat ini sebagai redirect
      // Hanya redirect jika belum di halaman login
      const current = `${window.location.pathname}${window.location.search}${window.location.hash}`
      if (!current.startsWith('/login')) {
        const redirect = encodeURIComponent(current)
        window.location.href = `/login?redirect=${redirect}`
      }
      // Jika sudah di login, tidak perlu redirect lagi (cegah loop)
    }
    return Promise.reject(error)
  },
)

export default defineBoot(({ app }) => {
  // for use inside Vue files (Options API) through this.$axios and this.$api

  app.config.globalProperties.$axios = axios
  // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
  //       so you won't necessarily have to import axios in each vue file

  app.config.globalProperties.$api = api
  // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
  //       so you can easily perform requests against your app's API
})

export { api }
